import { ToggleButton } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFieldset } from 'src/shared/components/form/formFieldset';
import { StyledToggleButtonGroup } from 'src/shared/components/organisms/styledToggleButtonGroup';
import { AssociationStatusItem } from '../models/associationStatusItem';

type AssociationStatusesProps = {
  initialValue: number[];
  options: AssociationStatusItem[];
  callback: (statuses: AssociationStatusItem[]) => void;
};

export const AssociationStatuses = (props: AssociationStatusesProps) => {
  const { initialValue, options, callback } = props;
  const { t } = useTranslation();

  const [selectedKeys, setSelectedKeys] = useState<number[]>(initialValue);

  const handleKeys = (event: React.MouseEvent<HTMLElement>, newKeys: number[]) => {
    if (selectedKeys.length === 1 && newKeys.length === 0) {
      return;
    }
    setSelectedKeys(newKeys);
    const selected = options.filter((item) => newKeys.includes(item.key));
    callback(selected);
  };

  return (
    <FormFieldset legend={t(t('association:status'))} noPadding>
      <StyledToggleButtonGroup value={selectedKeys} onChange={handleKeys} color='primary' size='small'>
        {options.map((x) => (
          <ToggleButton value={x.key} key={x.key}>
            {x.label}
          </ToggleButton>
        ))}
      </StyledToggleButtonGroup>
    </FormFieldset>
  );
};
